import { Outlet } from "react-router-dom";
import ModuleSubNav from "../../layouts/ModuleSubNav";

const WorkModule = () => {

const tabs = [
  { name: "My Work", path: "/tasks", end: true },
  { name: "Dashboard", path: "/tasks/dashboard" },
  { name: "Assignments", path: "/tasks/assignments" },
  { name: "Templates", path: "/tasks/templates" }
];

  return (
    <div>
      <ModuleSubNav tabs={tabs} />
      <Outlet />
    </div>
  );
};

export default WorkModule;
